import FetchStatusRepository    from "../../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository         from "../../../../domain/fundamentals/message/notify/NotifyRepository";
import RecordTemplateId         from "../../../../domain/record/template/RecordTemplateId";
import RecordTemplateRepository from "../../../../domain/record/template/RecordTemplateRepository";
import FetchStatusDataSource    from "../../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource         from "../../../../infrastructure/datasource/notify/NotifyDataSource";
import RecordTemplateDataSource from "../../../../infrastructure/datasource/record/template/RecordTemplateDataSource";
import RouterDispatcher         from "../../../../infrastructure/redux/router/RouterDispatcher";
import GetRecordTemplates       from "./GetRecordTemplates";

class DeleteRecordTemplate {
  constructor(
    private readonly dispatch,
    private readonly repository: RecordTemplateRepository = new RecordTemplateDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
    private readonly getRecordTemplates: GetRecordTemplates = new GetRecordTemplates(dispatch),
    private readonly routerDispatcher: RouterDispatcher = new RouterDispatcher(dispatch),
  ) {
  }

  public async execute(id: RecordTemplateId) {
    this.fetchStatusRepository.start();
    try {
      await this.repository.delete(id);
      await this.getRecordTemplates.execute();
      this.routerDispatcher.recordTemplates();
      this.notifyRepository.deleteSuccess();
    } catch (e) {
      this.notifyRepository.deleteFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default DeleteRecordTemplate;
